import SectionWrapper from './SectionWrapper';
import { Flex, FormControl, Input, FormErrorMessage } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from '../../../store/redux/hooks';
import { setSimpleField } from '../../../store/redux/slices/template.slice';
import { useTemplateFieldValidation } from './validation/useTemplateFieldValidation';
import { LabelWithTooltip } from './LabelWithTooltip';
import { useRef } from 'react';
import FieldEditIndicator from './FieldEditIndicator';
import { useFieldEditIndicator } from './hooks/useFieldEditIndicator';
import { CustomErrorIcon } from '../../../theme/icons/CustomErrorIcon';

const NotificationsFeature = () => {
  const notificationHeader = useAppSelector((s) => s.template.notificationHeader);
  const notificationHeaderRef = useRef<HTMLDivElement>(null);
  const { activeFieldRef, isFieldBeingEdited } = useFieldEditIndicator({
    fieldRefMap: { notificationHeader: notificationHeaderRef },
  });

  const dispatch = useAppDispatch();
  const { validateField, handleFocus } = useTemplateFieldValidation();
  const errors = useAppSelector((s) => s.templateErrors);

  const handleChange = (field: string, value: string) => {
    validateField(field, value);
    dispatch(setSimpleField({ field: 'notificationHeader', value }));
  };

  return (
    <SectionWrapper
      id="notifications-section"
      title="Notifications"
      tooltip="Settings used for triggered and geo-fencing notifications."
      openOnLoad={true}
    >
      <Flex direction="column" gap={4}>
        <FieldEditIndicator
          fieldRef={notificationHeaderRef}
          isFieldBeingEdited={isFieldBeingEdited}
          activeFieldRef={activeFieldRef}
          left="-40px"
          top="76px"
        >
          <FormControl
            mt={4}
            isRequired
            isInvalid={!!errors[`notificationHeader`]}
          >
            <LabelWithTooltip
              label="Notification Header"
              tooltip="Shown at the top of the push notification for Apple Wallet passes. Typically your brand or company name."
            />
            <Input
              value={notificationHeader}
              onChange={(e) =>
                handleChange('notificationHeader', e.target.value)
              }
              onFocus={() => handleFocus('notificationHeader')}
            />
            {errors[`notificationHeader`] && (
              <FormErrorMessage
                pl={2}
                display="flex"
                alignItems="center"
                gap={1.5}
              >
                <CustomErrorIcon />
                {errors[`notificationHeader`]}
              </FormErrorMessage>
            )}
          </FormControl>
        </FieldEditIndicator>
      </Flex>
    </SectionWrapper>
  );
};

export default NotificationsFeature;
